import React from 'react'

import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    width: 100%;
    margin-right: ${({ theme }) => theme.spacing.m};

    &:last-child {
      margin-right: ${({ theme }) => theme.spacing.empty};
    }
  }
`

export const HorizontalInputsWrapper = ({ children }: { children: React.ReactNode }): React.ReactElement => (
  <Container>{children}</Container>
)
